import { Check, Crown, ArrowUpRight } from "lucide-react";
import { PRICING } from "@/data/content";
import { Reveal, MaskReveal, SectionLabel, CtaButton, handleCta } from "./primitives";

export default function PricingSection() {
  return (
    <section id="investimento" className="relative bg-white py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-5 lg:px-8">
        <div className="mb-14 text-center">
          <Reveal className="flex justify-center"><SectionLabel>INVESTIMENTO</SectionLabel></Reveal>
          <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-brand-navy sm:text-5xl">
            <MaskReveal className="inline-block" lines={["Comece sua preparação."]} />
          </h2>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1.05fr_0.95fr]">
          {/* Founder card */}
          <Reveal>
            <div className="relative h-full overflow-hidden rounded-[28px] border border-brand-gold/40 bg-brand-navy p-8 text-white shadow-[0_40px_80px_-30px_rgba(10,25,47,0.5)] md:p-10">
              <div className="noise-overlay pointer-events-none absolute inset-0 opacity-[0.05]" />
              <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-brand-gold/20 blur-3xl" />

              <div className="relative flex items-center gap-2">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-gold px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-brand-navy">
                  <Crown className="h-3.5 w-3.5" /> {PRICING.founderLabel}
                </span>
              </div>

              <div className="relative mt-8 flex items-end gap-3">
                <span className="font-display text-6xl font-semibold tracking-tight text-brand-gold md:text-7xl">
                  {PRICING.founderPrice}
                </span>
              </div>
              <p className="relative mt-2 text-sm text-white/55">{PRICING.founderNote}</p>

              <CtaButton
                size="lg"
                className="relative mt-8 w-full"
                onClick={() => handleCta("checkout")}
                data-testid="pricing-cta"
              >
                {PRICING.cta}
                <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </CtaButton>

              {/* lot progression */}
              <div className="relative mt-8 border-t border-white/10 pt-6">
                <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-white/40">
                  Progressão planejada de lotes
                </p>
                <div className="space-y-2.5">
                  {PRICING.lots.map((lot) => (
                    <div
                      key={lot.label}
                      className={`flex items-center justify-between rounded-xl px-4 py-2.5 text-sm ${
                        lot.current ? "bg-white/10 text-white" : "text-white/45"
                      }`}
                    >
                      <span className={`font-medium ${lot.past ? "line-through decoration-white/40" : ""}`}>{lot.label}</span>
                      <span className={`font-semibold ${lot.current ? "text-brand-gold" : ""} ${lot.past ? "line-through decoration-white/40" : ""}`}>{lot.price}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>

          {/* Checklist */}
          <Reveal delay={0.12}>
            <div className="h-full rounded-[28px] border border-brand-navy/8 bg-brand-mist/50 p-8 md:p-10">
              <p className="font-display text-xl font-semibold tracking-tight text-brand-navy">
                O que está incluído
              </p>
              <p className="mt-2 text-sm text-brand-navy/55">
                O valor está na experiência completa de preparação — não na quantidade isolada de aulas.
              </p>
              <ul className="mt-7 grid gap-3 sm:grid-cols-2">
                {PRICING.checklist.map((item) => (
                  <li key={item} className="flex items-center gap-3 rounded-xl border border-brand-navy/8 bg-white px-4 py-3">
                    <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-emerald-500/10 text-emerald-600">
                      <Check className="h-3.5 w-3.5" />
                    </span>
                    <span className="text-[13px] font-medium text-brand-navy/80">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
